module.exports = __webpack_public_path__ + "media/images/app/mail-magazine-fec3ac91db343fba309d791190f8f362.svg";